import styled from 'styled-components';
import { scale } from '../copied/Animations';

const TeaserImage = styled.img`
  animation: ${scale} 0.3s ease forwards;
  height: auto;
  min-width: 60px;
  transform: scale(0);
  transform-origin: ${props => (props.user ? 'bottom left' : 'bottom right')};
  width: 100%;
  display: block;
`;

export default TeaserImage;